import { render, staticRenderFns } from "./video-select.vue?vue&type=template&id=b4bf29b8&scoped=true&"
import script from "./video-select.vue?vue&type=script&lang=js&"
export * from "./video-select.vue?vue&type=script&lang=js&"
import style0 from "./video-select.vue?vue&type=style&index=0&id=b4bf29b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bf29b8",
  null
  
)

export default component.exports